module.exports = __webpack_public_path__ + "static/nutrition_bar_chart_layout-fe2492345abd9289a352a3860cff5880.png";